// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { call, put, takeLatest } from 'redux-saga/effects';
import AddressDal from './../../../dal/AddressDal';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import {
    GET_ADDRESS_VALIDATION_DATA,
    GET_WIC_ADDRESS_DATA,
    RESET_WIC_ADDRESS_DATA,
    SAVE_WIC_SELECTED_ADDRESS_DATA,
    getAddressValidationData,
    getAddressValidationDataSuccess,
    getWicAddressData,
    getWicAddressDataSuccess,
    resetWicAddressData,
    resetWicAddressDataSuccess,
    saveWicSelectedAddressData,
    saveWicSelectedAddressDataSuccess,
} from './../../../store/address';

function* getValidatedAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: GET_ADDRESS_VALIDATION_DATA,
            })
        );

        const response = yield call(
            AddressDal.getValidatedAddresses,
            request.payload
        );

        yield put(getAddressValidationDataSuccess(response));

        yield put(
            actionStatusSuccess({
                actionName: GET_ADDRESS_VALIDATION_DATA,
            })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_ADDRESS_VALIDATION_DATA,
                error: e,
            })
        );
    }
}

export function* getWicAddresses(request: any): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: GET_WIC_ADDRESS_DATA }));
        const response = yield call(
            AddressDal.getWicAddresses,
            request.payload
        );

        yield put(getWicAddressDataSuccess(response));
        yield put(actionStatusSuccess({ actionName: GET_WIC_ADDRESS_DATA }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_WIC_ADDRESS_DATA,
                error: e,
            })
        );
    }
}

export function* saveWicAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({ actionName: SAVE_WIC_SELECTED_ADDRESS_DATA })
        );
        yield put(saveWicSelectedAddressDataSuccess(request.payload));

        yield put(
            actionStatusSuccess({ actionName: SAVE_WIC_SELECTED_ADDRESS_DATA })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: SAVE_WIC_SELECTED_ADDRESS_DATA,
                error: e,
            })
        );
    }
}

export function* resetWicAddress(): IterableIterator<any> {
    try {
        yield put(actionStatusStarted({ actionName: RESET_WIC_ADDRESS_DATA }));

        yield put(resetWicAddressDataSuccess());

        yield put(actionStatusSuccess({ actionName: RESET_WIC_ADDRESS_DATA }));
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: RESET_WIC_ADDRESS_DATA,
                error: e,
            })
        );
    }
}

export default [
    takeLatest(`${getAddressValidationData}`, getValidatedAddress),
    takeLatest(`${getWicAddressData}`, getWicAddresses),
    takeLatest(`${saveWicSelectedAddressData}`, saveWicAddress),
    takeLatest(`${resetWicAddressData}`, resetWicAddress),
];
